import { CircularProgress, Grid } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { APIHeader } from '../..';
import ValueScoreAdjustmentModal from '../../pages/ListTableAndTrackingFIle/ValueScoreAdjustmentModal';
import {
  createGetValueAdjustmentOptions,
  saveValueAdjustment,
} from '../../queries/overviewQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { VSModalLoader } from '../../styles';
import { isEmptyObject, validateInputFields } from '../../utils';

ValueScoreModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  apiConfig: PropTypes.shape({
    uiURL: PropTypes.string.isRequired,
  }),
  userInfo: PropTypes.object,
  errorInAPI: PropTypes.object,
};

function ValueScoreModal(props) {
  const { apiConfig, userInfo, errorInAPI } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const pecrId = searchParams.get('id');
  const validationDefaultState = {
    DeleteComment: '',
    ManagerComments: '',
  };
  const [openVSAdjustmentModal, setOpenVSAdjustmentModal] = useState(false);
  const [adjustmentModalData, setAdjustmentModalData] = useState({});
  const [adjustmentModalDataSaved, setAdjustmentModalDataSaved] =
    useState(false);
  const [inputValidationMessage, setInputValidationMessage] = useState(
    validationDefaultState
  );
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: saveValueAdjustment,
    onSuccess: data => {
      props.onClose();
      setAdjustmentModalDataSaved(!adjustmentModalDataSaved);
      queryClient.invalidateQueries({
        queryKey: ['value-and-effort', { pecrId }],
      });
    },
    onError: error => {
      console.error('Error saving value adjustment:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });
  const { data, isLoading, error } = useQuery(
    createGetValueAdjustmentOptions(
      { pecrId, siteId: props.siteId },
      { enabled: !!pecrId }
    )
  );
  console.log('Value Adjustment Data:', data);

  const handleModalChange = event => {
    setAdjustmentModalData(prevState => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
    if (event.target.name === 'ManagerComments') {
      const ValidationMessage = validateInputFields(event.target.value, t);
      setInputValidationMessage({
        ...inputValidationMessage,
        [event.target.name]: ValidationMessage,
      });
    }
  };

  const closeModal = () => {
    props.onClose();
    setOpenVSAdjustmentModal(false);
    setAdjustmentModalData({});
    setInputValidationMessage(validationDefaultState);
  };

  const handleSave = () => {
    const saveData = {
      pecrId,
      siteId: props.siteId,
      scoreAdjustment: adjustmentModalData.ManagerValueAdjustment,
      justification: adjustmentModalData.ManagerComments,
    };
    mutate(saveData);
  };

  return (
    <>
      {data && (
        <ValueScoreAdjustmentModal
          onSaveClick={handleSave}
          onCancelClick={closeModal}
          adjustmentModalData={adjustmentModalData}
          openVSAdjustmentModal={data}
          handleModalChange={handleModalChange}
          inputValidationMessage={inputValidationMessage.ManagerComments}
        />
      )}
    </>
  );
}

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};
export default connect(mapStateToProps, null)(ValueScoreModal);
